module.exports = {
          srcSet: __webpack_public_path__ + "07408b7b9891009160666569413f36fd-25.png"+" 25w",
          images:[ {path: __webpack_public_path__ + "07408b7b9891009160666569413f36fd-25.png",width: 25,height: 25}],
          src: __webpack_public_path__ + "07408b7b9891009160666569413f36fd-25.png",
          toString:function(){return __webpack_public_path__ + "07408b7b9891009160666569413f36fd-25.png"},
          
          width: 25,
          height: 25
        }